import React, { useContext, useState } from "react";
import { useMediaQuery } from "react-responsive";

import {
  Modal as BaseModal,
  Callout,
  CheckboxListInput,
  Form,
  ModalProps,
  SubmitButtons,
  VSpace,
} from "@examspark/common-ui";
import { IconCautionSolid } from "@examspark/common-ui/dist/components/icons";
import Modal, {
  PaddedBody,
} from "@examspark/common-ui/dist/components/modals/Modal";
import { Subject } from "@examspark/types";

import { useAppContext } from "../../../providers/AppContext";
import { LTIContext } from "../../../providers/LTIProvider";
import NewClassroomGoogle from "../new-classroom/NewClassroomGoogle";
import NewClassroomLTI from "../new-classroom/NewClassroomLTI";
import NewClassroomManual from "../new-classroom/NewClassroomManual";

const NewSectionModal = (
  props: ModalProps & {
    // I would prefer these be showFoo...
    // hideCourseInputs?: boolean;
    hideCourseInput: boolean;
    hideSubjectInput: boolean;
    hideGradeInput: boolean;

    allowedSubjects?: string[];
    overrideSubjects?: Subject[];
    disableGoogleClassroom?: boolean;
    onCreate: () => void;
  },
) => {
  const lti = useContext(LTIContext);
  const [state] = useAppContext();
  const [view, setView] = useState<"method" | "setup">("method");
  const [setupType, setSetupType] = useState<"manual" | "google" | "lms">(
    lti?.token.data?.context_id ? "lms" : "manual",
  );
  const needsFullscreen = useMediaQuery({ maxWidth: "600px" });

  const displayNoStandaloneSetupCallout = setupType !== "lms" && !!lti;
  const displayNoLTISetupCallout = setupType === "lms" && !lti;
  const displayNoRosterCallout = !state.app?.config?.allowRostering;
  const noNext = displayNoStandaloneSetupCallout || displayNoLTISetupCallout;

  return (
    <Modal
      {...props}
      size={needsFullscreen ? "large" : "medium"}
      onAfterClose={() => {
        setSetupType(lti?.token.data?.context_id ? "lms" : "manual");
        setView("method");
      }}
      title="New Classroom"
      customBody={
        <>
          {view === "method" && (
            <>
              <BaseModal.Body>
                <PaddedBody>
                  <VSpace>
                    {(displayNoLTISetupCallout ||
                      displayNoRosterCallout ||
                      displayNoStandaloneSetupCallout) && (
                      <VSpace size="0.5rem">
                        {displayNoLTISetupCallout && (
                          <Callout
                            icon={
                              <IconCautionSolid fill="#f6b723" width="16" />
                            }
                          >
                            In order to use this setup method, you must launch
                            this application from your LMS. For additional
                            assistance, please contact your LMS administrator.
                          </Callout>
                        )}
                        {displayNoStandaloneSetupCallout && (
                          <Callout
                            icon={
                              <IconCautionSolid fill="#f6b723" width="16" />
                            }
                          >
                            This method is not available when launched from an
                            LMS.
                          </Callout>
                        )}
                      </VSpace>
                    )}
                    <Form.FieldList style={{ gap: "2rem" }}>
                      <div>
                        <CheckboxListInput>
                          <CheckboxListInput.Item
                            checked={setupType === "manual"}
                            onClick={() => setSetupType("manual")}
                            label="Create classroom manually"
                          />
                          {!displayNoRosterCallout && (
                            <>
                              <CheckboxListInput.Item
                                checked={setupType === "google"}
                                onClick={() => setSetupType("google")}
                                label="Create classroom for Google Classroom®"
                              />
                              <CheckboxListInput.Item
                                checked={setupType === "lms"}
                                onClick={() => setSetupType("lms")}
                                label="Create classroom for your LMS"
                              />
                            </>
                          )}
                        </CheckboxListInput>
                      </div>
                    </Form.FieldList>
                  </VSpace>
                </PaddedBody>
              </BaseModal.Body>
              <BaseModal.BasicFooter>
                <SubmitButtons
                  submitLabel="Next"
                  isSubmitDisabled={noNext}
                  onCancel={props.onRequestClose}
                  onSubmit={() => {
                    setView("setup");
                  }}
                />
              </BaseModal.BasicFooter>
            </>
          )}
          {view === "setup" && (
            <>
              {setupType === "google" && (
                <NewClassroomGoogle
                  onCreate={props.onCreate}
                  onRequestClose={props.onRequestClose}
                  onBack={() => setView("method")}
                >
                  Google
                </NewClassroomGoogle>
              )}
              {setupType === "lms" && (
                <NewClassroomLTI
                  onCreate={props.onCreate}
                  onRequestClose={props.onRequestClose}
                  onBack={() => setView("method")}
                  hideCourseInput={props.hideCourseInput}
                  hideSubjectInput={props.hideSubjectInput}
                  hideGradeInput={props.hideGradeInput}
                />
              )}
              {setupType === "manual" && (
                <NewClassroomManual
                  // hideCourseInputs={props.hideCourseInputs}
                  hideCourseInput={props.hideCourseInput}
                  hideSubjectInput={props.hideSubjectInput}
                  hideGradeInput={props.hideGradeInput}
                  allowedSubjects={props.allowedSubjects}
                  overrideSubjects={props.overrideSubjects}
                  onCreate={props.onCreate}
                  onRequestClose={props.onRequestClose}
                  onBack={() => setView("method")}
                />
              )}
            </>
          )}
        </>
      }
    />
  );
};

export default NewSectionModal;
